<template>
  <div
    :class="[
      'relative bg-no-repeat bg-cover text-white bg-primary rounded-b-3xl',
      '-top-14 h-80 md:h-[26rem]',
      `bg-[image:var(--mobile-background-url)]`,
      'lg:-top-20 lg:-mb-4 lg:h-[80dvh] lg:min-h-[30rem] lg:max-h-[34rem]',
      'bg-right md:bg-[center_bottom_-5rem] lg:bg-[center_bottom_-10rem] xl:bg-[center_bottom_-15rem] 2xl:bg-[center_bottom_-28rem]'
    ]"
    :style="tailwindsCssVars"
    ref="container"
  >
    <div class="size-full flex flex-row items-end bg-gradient-to-b from-black/40"></div>
  </div>
</template>

<script lang="ts" setup>
const $appConfig = useRuntimeConfig().public.app

const container = ref<HTMLElement>()

// tailwinds doesn't handle dynamic images, this is the workaround
const tailwindsCssVars = {
  '--mobile-background-url': `url('${$appConfig.cdnEndpoint}/images/rv-pop-sell.webp')`
}
</script>
